/**
 * Antes do login centralizado, a sessão vivia em um store zustand persistido
 * (`src/stores/auth-store.ts`, removido). Ele gravava nome, e-mail, `revendaId` e
 * permissões no `localStorage`, e o logout só marcava `isAuthenticated: false` e o
 * `user` continuava em disco. Como o `localStorage` não expira, quem usou o site
 * antes desta versão carrega esses dados até limpar os dados do navegador.
 *
 * Por isso a limpeza acontece no carregamento do app, e não no logout: quem já
 * deslogou não passa mais por lá.
 *
 * Isso pode sair quando a versão nova estiver em produção há tempo
 * suficiente para todo mundo ter aberto o site pelo menos uma vez.
 */
export const CHAVE_STORE_LEGADO = 'ar-auth-store';

export function limparSessaoLegada() {
  try {
    localStorage.removeItem(CHAVE_STORE_LEGADO);
  } catch {
    // Navegador com armazenamento bloqueado: não há o que limpar, e isso não pode
    // impedir o carregamento do app.
  }
}
